import React from "react";
import styled from "styled-components";
import { object, func } from "prop-types";

import EventIcon from "@material-ui/icons/Event";

import { color } from "@components/shared/utils";

const DateInputContainer = styled.div`
  position: relative;
  max-width: 12.5rem;
`;

const DateInputField = styled.input`
  border: 2px solid ${color("grey")};
  height: 2.5rem;
  padding: 0.75rem;
  width: 100%;

  &:focus {
    outline: none;
  }
`;

const StyledEventIcon = styled(EventIcon)`
  bottom: 0;
  color: ${color("grey")};
  cursor: pointer;
  margin: auto;
  position: absolute;
  right: 0.5rem;
  top: 0;

  height: 20px !important;
  width: 20px !important;
`;

const DatePickerTextField = ({ inputRef, onClick, ...props }) => {
  return (
    <DateInputContainer>
      <DateInputField
        readOnly
        type="text"
        ref={inputRef}
        onClick={onClick}
        {...props}
      />
      <StyledEventIcon onClick={onClick} />
    </DateInputContainer>
  );
};

DatePickerTextField.propTypes = {
  inputRef: object.isRequired,
  onClick: func.isRequired,
};

export default DatePickerTextField;
